jQuery(document).ready(function($) {
  initHellobar();

  // Function to handle the synchronization
  syncAccordionAndSwiper();
});

// Global variable to store the active slide index
var activeSlideIndex = 0;

// Function to handle the accordion and Swiper slider synchronization
function syncAccordionAndSwiper() {
  var myVideoSwiper;

  // Function to update the active accordion item based on the active Swiper slide
  function updateActiveAccordionItem() {
	// Remove the "active" class from all accordion items
	jQuery(".home .wp-block-kadence-pane").removeClass("active");

	// Find the corresponding accordion item and add the "active" class
	var accordionItem = jQuery(".home .wp-block-kadence-pane").eq(activeSlideIndex);
	accordionItem.addClass("active");
  }

  // Delay the Swiper initialization until the page is fully loaded
  window.onload = function() {
	myVideoSwiper = new Swiper(".swiper-video-slider-section .swiper-container", {
	  direction: "horizontal",
	  loop: false,
	  autoHeight: false,
	  slidesPerView: 1,
	  spaceBetween: 10,
	  allowTouchMove: false,
	  centeredSlides: false,
	  effect: "fade",
	  // Initial slide will be set once the Swiper is initialized
	  // initialSlide: 0,
	  //loopedSlides: 10,

	  breakpoints: {
		// when window width is >= 320px
		768: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
		1024: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
		1200: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
	  },

	  on: {
		init: function() {
		  // On page load, add the "active" class to the first accordion item and the first swiper slide
		  jQuery(".home .wp-block-kadence-pane").first().addClass("active");
		  jQuery(".swiper-video-slider-section .swiper-container .swiper-slide").first().addClass("active");
		  updateActiveAccordionItem(); // Update active accordion item on Swiper init
		},
		slideChange: function() {
		  activeSlideIndex = myVideoSwiper.activeIndex; // Update the global variable with the new active slide index
		  updateActiveAccordionItem();
		},
	  },
	});

	// Attach click event to accordion container (using event delegation)
	jQuery(".home .wp-block-kadence-accordion").on("click", ".wp-block-kadence-pane", function() {
	  var clickedIndex = jQuery(this).index(".home .wp-block-kadence-pane");
	  if (clickedIndex !== activeSlideIndex) {
		myVideoSwiper.slideTo(clickedIndex, 200, false);
	  }
	});
  };
  
  // Call the function to update the active accordion item initially (in case Swiper is already initialized)
  updateActiveAccordionItem();
}


  
 function initPreloaderScreen() {
	 setTimeout(function(){
		 jQuery('.home #loader').addClass('animated zoomOut');		
	 }, 1000);
	 setTimeout(function(){		
		 jQuery('.home #loader-wrapper').fadeOut('slow');	
		 jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	 }, 1550);
	 initSubmenus();
 }

function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}


function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}